import { Component, OnInit } from '@angular/core';
import {PopinOneComponent} from '../popin-one/popin-one.component';
import {NotificationService} from '../services/notification.service';
import {Data} from '../providers/data.provider';
import {DatasaveService} from '../services/datasave.service';
import {PopinVisit} from '../models/popinvisit.model';
import {MailSent} from '../models/mailsent.model';

@Component({
  selector: 'app-popin-exit',
  templateUrl: './popin-exit.component.html',
  styleUrls: ['./popin-exit.component.css']
})
export class PopinExitComponent implements OnInit {

  constructor(private notifService: NotificationService,
              private datasaveService: DatasaveService,
              private data: Data) { }

  public dest: any;
  public exped: any;
  public popinvisit: PopinVisit;
  public mailsent: MailSent;
  public mailtype: string;

  ngOnInit(): void {
    this.dest = this.data.storage.huntingManager;
    this.exped = {
      'company': PopinOneComponent.customer,
      'visitorContent': 'Simple visite',
      'website': this.data.storage.website,
    };

    if (PopinOneComponent.isCustomer) {
      this.mailtype = PopinOneComponent.MAILTYPE_SIMPLEVISITCLIENT;
    } else {
      this.mailtype = PopinOneComponent.MAILTYPE_SIMPLEVISITPROSPECT;
    }

    this.mailsent = {
      popin: PopinOneComponent.popinId,
      mailType: this.mailtype,
      recipient: this.dest['_id']
    };

    this.popinvisit = {
      popin: PopinOneComponent.popinId,
      companyIdentifier: PopinOneComponent.customer['SIREN'],
      isCustomer: PopinOneComponent.isCustomer,
      visitType: PopinOneComponent.VISITTYPE_SIMPLEVISITE,
      product: null,
      visitRandomId: PopinOneComponent.visitRandomId,
      visitorContent: 'Simple visite'
    };

    this.notifService.sendProspectNotificationToManager(this.dest, this.exped)
      .then(() => {
        this.datasaveService.saveMailData(this.mailsent);
        this.datasaveService.saveVisitData(this.popinvisit);
        window.parent.postMessage('exit', PopinOneComponent.uri);
      })
      .catch(error => console.log(error));
  }

}
